<template>
  <div>
    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-header d-flex align-items-center">
          <h3
            class="box-title"
            style="display: inline-block; margin-right: 5px"
          >
            Current Schedules
          </h3>

          <!-- <button class="btn btn-default align-middle" @click="refreshData">
            <i class="fa fa-refresh"></i>
          </button> -->
        </div>
        <div class="box-body">
          <div>
            <table :id="tableId" class="table table-bordered table-striped" />
          </div>
        </div>
        <div class="alert alert-info text-md">
          Please note: Usage statistics are processed at the end of each month.
          Monthly reports will be sent out as they become available, typically
          within 3 to 5 business days.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      role: "",
      tableRef: null,
      tableId:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now(),
      // columns to keep = scheduler, startDaet, scchedulePeriod, Parttnertype, email, selectpartyname
      tableColumns: [
        {
          data: "scheduler",
          title: "Scheduled By",
          type: "string",
          render: null,
        },
        {
          data: "schedulePeriod",
          title: "Schedule Period",
          type: "Date",
          render: null,
        },
        {
          data: "nextDateTrigger",
          title: "Next Schedule Date",
          type: "Date",
          render: function (data, type, row) {
            return new Date(data).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          },
        },
        {
          data: "partnerType",
          title: "Partner Type",
          type: "string",
          render: null,
        },
        {
          data: "email",
          title: "Receiver Email",
          type: "string",
          render: null,
        },
        {
          data: "selectedPartyName",
          title: "Instituion Name",
          type: "string",
          render: null,
        },
      ],
      isLoading: false,
      isError: false,
      partner: "",
      tableData: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("schedule", ["schedulesData"]),
  },
  mounted() {
    this.role = this.loggedInUser.role;
    this.$store.dispatch("schedule/setScheduleData");
  },
  watch: {
    schedulesData(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        if (this.tableRef != null) this.tableRef.destroy();
        let filteredData = newVal;
        if (this.role == "Librarian") {
          var filter = this.loggedInUser.username;
          filteredData = filteredData.filter((row) => row.scheduler === filter);
        }
        this.tableData = filteredData;
        this.buildTable();
      }
    },
  },
  methods: {
    // setTableData() {
    //   this.$store
    //     .dispatch("schedule/setScheduleData")
    //     .then(() => {
    //       // console.log(this.data);
    //       let filteredData = this.data;

    //       if (this.role != "Sales") {
    //         var filter = this.loggedInUser.username;
    //         filteredData = this.data.filter((row) => row.scheduler === filter);
    //       }

    //       // Handle success
    //       this.buildTable(filteredData);
    //     })
    //     .catch((error) => {
    //       // Handle error
    //       console.error("ERROR Getting Data from Schedule Table", error);
    //     });
    // },
    // refreshData() {
    //   this.$store.dispatch("schedule/setScheduleData").then(() => {
    //     // console.log(this.scheduleData);
    //     let filteredData = this.data;

    //     if (this.role != "Sales") {
    //       var filter = this.loggedInUser.username;
    //       filteredData = this.data.filter((row) => row.scheduler === filter);
    //     }

    //     // Update the table with new data
    //     this.tableRef.clear().rows.add(filteredData).draw();
    //   });
    // },
    buildTable() {
      this.tableRef = $("#" + this.tableId).DataTable({
        destroy: true,
        deferRender: true,
        aaData: this.tableData,
        aoColumns: this.tableColumns,
        paging: true,
        pagingType: "full_numbers",
        lengthChange: true,
        searching: true,
        ordering: true,
        order: [[1, "desc"]],
        info: false,
        autoWidth: false,
        pageLength: 10,
        dom: '<"top"Bt><"bottom"<"row"<"col-md-6 ln1"il><"col-md-6 pull-right"p>>>',
        buttons: [
          {
            extend: "excel",
            text: '<i class="fa fa-file-excel-o"></i> Excel',
            className: "btn btn-success btn-xs",
          },
          {
            extend: "copy",
            text: '<i class="fa fa-copy"></i> Copy',
            className: "btn btn-danger btn-xs",
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.text-md {
  font-size: 15px;
  font-weight: bold;
}
</style>

<style>
.dataTables_wrapper .dataTables_paginate .paginate_button {
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/usage/SchedulePanel.vue